import { PlayerStatChartConfigDto, BatterSingleSessionReportChartConfigDto, ChartType } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

const BatterSingleSessionBattingStatChartSidebar = ({
  extraChartData,
  setTempLayout,
  tempLayout,
  chartNumber,
}: { chartNumber: number } & ChartConfigProps<PlayerStatChartConfigDto, BatterSingleSessionReportChartConfigDto>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  const chartKey = `batterSingleSessionBattingStatChartConfig_${chartNumber}`;
  const chartTitleKey = `BatterSingleSessionBattingStatChart_${chartNumber}`;

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle(chartTitleKey as ChartType, extraChartData)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={extraChartData.availableStats}
        selected={extraChartData.playerStat}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            [chartKey]: {
              ...tempLayout[chartKey],
              playerStat: selected,
            },
          })
        }
        disabled={false}
      />
    </div>
  );
};

const BatterSingleSessionBattingStatChartSidebar_1 = (
  props: ChartConfigProps<PlayerStatChartConfigDto, BatterSingleSessionReportChartConfigDto>
) => {
  return <BatterSingleSessionBattingStatChartSidebar chartNumber={1} {...props} />;
};

const BatterSingleSessionBattingStatChartSidebar_2 = (
  props: ChartConfigProps<PlayerStatChartConfigDto, BatterSingleSessionReportChartConfigDto>
) => {
  return <BatterSingleSessionBattingStatChartSidebar chartNumber={2} {...props} />;
};

const BatterSingleSessionBattingStatChartSidebar_3 = (
  props: ChartConfigProps<PlayerStatChartConfigDto, BatterSingleSessionReportChartConfigDto>
) => {
  return <BatterSingleSessionBattingStatChartSidebar chartNumber={3} {...props} />;
};

const BatterSingleSessionBattingStatChartSidebar_4 = (
  props: ChartConfigProps<PlayerStatChartConfigDto, BatterSingleSessionReportChartConfigDto>
) => {
  return <BatterSingleSessionBattingStatChartSidebar chartNumber={4} {...props} />;
};

const BatterSingleSessionBattingStatChartSidebar_5 = (
  props: ChartConfigProps<PlayerStatChartConfigDto, BatterSingleSessionReportChartConfigDto>
) => {
  return <BatterSingleSessionBattingStatChartSidebar chartNumber={5} {...props} />;
};

const BatterSingleSessionBattingStatChartSidebar_6 = (
  props: ChartConfigProps<PlayerStatChartConfigDto, BatterSingleSessionReportChartConfigDto>
) => {
  return <BatterSingleSessionBattingStatChartSidebar chartNumber={6} {...props} />;
};

export {
  BatterSingleSessionBattingStatChartSidebar_1,
  BatterSingleSessionBattingStatChartSidebar_2,
  BatterSingleSessionBattingStatChartSidebar_3,
  BatterSingleSessionBattingStatChartSidebar_4,
  BatterSingleSessionBattingStatChartSidebar_5,
  BatterSingleSessionBattingStatChartSidebar_6,
};
